import React, { useEffect, useState } from "react";
import { LuPlus } from "react-icons/lu";
import Utils from "../utils/utils";
import { useToast } from "../components/ToastContext";
import InstructorsList from "../components/InstructorsList";

const Instructors = () => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const token = Utils.getToken();

  const showToast = useToast();

  const [instructors, setInstructors] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const handleChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${SERVER_URL}/instructors/`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData), // Send form data as JSON
      });

      if (response.ok) {
        const ret = await response.json();
        showToast("Instructor added", "success", false, 2000);
        setInstructors((prev) => [...prev, ret.instructor]);
        setFormData({
          name: "",
          email: "",
          mobile: "",
        });
      } else {
        const ret = await response.json();
        if (response.status === 409) {
          showToast(ret.message, "error", true, 3000);
        }
        console.error("Error submitting the form:", response.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchInstructors = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/instructors/`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const ret = await response.json();
        setInstructors(ret.instructors);
      } else {
        const ret = await response.json();
        showToast(ret.message, "error", true, 3000);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchInstructors();
  }, []);

  const [editingInstructor, setEditingInstructor] = useState(null);
  const [updatedInstructor, setUpdatedInstructor] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const handleEditClick = (instructor) => {
    setEditingInstructor(instructor);
    setUpdatedInstructor({
      name: instructor.name,
      email: instructor.email,
      mobile: instructor.mobile,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedInstructor({
      ...updatedInstructor,
      [name]: value,
    });
  };

  // Handle saving the updated instructor data
  const handleSaveClick = () => {
    // Save the updated data (you can send it to an API here)
    console.log("Saving updated instructor:", updatedInstructor);
    setEditingInstructor(null); // Exit editing mode
  };

  return (
    <div className="shadow-none p-4 overflow-y-auto space-y-4 h-[calc(100vh-65px)]">
      <div className="flex">
        <div className="dropdown  ">
          <button
            tabIndex={0}
            className="px-3 py-1 flex justify-center items-center gap-1 btn-sm cursor-pointer tracking-[.1em] uppercase border border-pink-700 rounded-lg text-pink-700 hover:text-pink-800 hover:border-pink-800 hover:shadow-lg "
          >
            <LuPlus className="size-5" />
            ADD INSTRUCTOR
          </button>

          <form
            tabIndex={0}
            className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow"
            onSubmit={handleSubmit}
          >
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name} // Bind the value to state
                onChange={handleChange} // Update the state on input change
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email} // Bind the value to state
                onChange={handleChange} // Update the state on input change
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            <div>
              <label
                htmlFor="mobile"
                className="block text-sm font-medium text-gray-700"
              >
                Mobile
              </label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={formData.mobile} // Bind the value to state
                onChange={handleChange} // Update the state on input change
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <button
              type="submit"
              className="w-full p-2 mt-4 bg-blue-500 text-white rounded-md shadow-sm hover:bg-blue-600 focus:ring-2 focus:ring-blue-500"
            >
              Submit
            </button>
          </form>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="table min-w-full table-auto">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email Id</th>
              <th>Mobile</th>
              <th></th>
            </tr>
          </thead>
          <InstructorsList
            instructors={instructors}
            setInstructors={setInstructors}
          />
          <tfoot>
            <tr>
              <th>Name</th>
              <th>Email Id</th>
              <th>Mobile</th>
              <th></th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default Instructors;
